import { render, staticRenderFns } from "./AdminReports.vue?vue&type=template&id=7dbf00fe&scoped=true"
import script from "./AdminReports.vue?vue&type=script&lang=js"
export * from "./AdminReports.vue?vue&type=script&lang=js"
import style0 from "./AdminReports.vue?vue&type=style&index=0&id=7dbf00fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbf00fe",
  null
  
)

export default component.exports